// removed by extract-text-webpack-plugin
module.exports = {"Tags":"src-components-header----tags-module---Tags---1Eiol","Tags__label":"src-components-header----tags-module---Tags__label---EBASF","Tags__button":"src-components-header----tags-module---Tags__button---1zr3U","Tags__list":"src-components-header----tags-module---Tags__list---1bmgJ","Tags__tag":"src-components-header----tags-module---Tags__tag---t364g","spinAround":"src-components-header----tags-module---spinAround---Aa0FO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/tags.module.scss
// module id = 217
// module chunks = 114276838955818 184470312924441